// extracted by mini-css-extract-plugin
export default {"footerWrap":"Footer_footerWrap__80Xv2","footerText":"Footer_footerText__n14sU","footerActions":"Footer_footerActions__0xLJt"};